module.exports = __webpack_public_path__ + "img/8.fe85aa22.png";